import {getProduct, getProductStyle} from 'service/ProductService';
import {ItemType} from 'shared/components/Product/Item';
import {PartialRoom} from 'shared/types/PartialRoom';
import {
    appendProductTo3dPreview,
    ProductInterface,
} from 'components/customer/RoomPlanner/helpers/appendProductTo3dPreview';
import {CabinetMesh} from 'components/customer/RoomPlanner/types';

export const quickAppendProductTo3dPreview = async (
    item: ItemType | {id: number},
    quantity: number,
    Width: number,
    room: PartialRoom,
    cabinetGroupListRef: React.MutableRefObject<CabinetMesh[]>
) => {
    const productData = await getProduct(item.id);

    if (productData) {
        const productStyle = await getProductStyle(productData.style);

        if (productStyle) {
            const product: ProductInterface = {
                cabinet_width: Width,
                cabinet_quantity: quantity,
                cabinet_type: item.id,
                shelf_position: [],
                shelf_style: [],
                shelf_offset: [],
            };

            switch (productStyle.styleName) {
                case 'Base':
                    product.cabinet_height = Number(room.baseHeight);
                    product.cabinet_depth = Number(room.baseDepth);
                    break;

                case 'Pantry':
                case 'Tall':
                    product.cabinet_height = Number(room.tallHeight);
                    product.cabinet_depth = Number(room.tallDepth);
                    break;

                case 'Upper':
                    product.cabinet_height = Number(room.upperHeight);
                    product.cabinet_depth = Number(room.upperDepth);
                    break;
            }

            return appendProductTo3dPreview(
                product,
                productData.id,
                room,
                cabinetGroupListRef,
                false,
                true,
                true
            );
        }
    }
};
